import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/style/style.scss';
import ElementPlus from 'element-plus';
import ru from 'element-plus/es/locale/lang/ru';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import 'dayjs/locale/ru';
import * as Sentry from '@sentry/vue';

const app = createApp(App);

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    app,
    dsn: 'https://a1f4eb5147074726b589fd2fce6645f3@track.dev.normacs.info/9',
    environment: process.env.NODE_ENV,
    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: ['specdev.normacs.info', 'spec.dev.normacs.info', /^\//],
    tracesSampleRate: 0.1,
  });
}

app.use(ElementPlus, {
  locale: ru,
});

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.config.productionTip = false;

app.use(store);
app.use(router);

app.mount('#app');
